import React, { useState, useRef } from "react";
import { createPortal } from "react-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const CalendarIcon = ({ onClick }) => (
  <button
    onClick={onClick}
    className="w-4 h-4 text-gray-500 hover:text-gray-700"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5"
      />
    </svg>
  </button>
);

const DatePickerField = ({
  label,
  value,
  onChange,
  className = "",
  disabled = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const inputRef = useRef(null);

  const handleDateSelect = (date) => {
    onChange(date);
    setIsOpen(false);
  };

  const Calendar = () => {
    if (!isOpen) return null;

    const rect = inputRef.current.getBoundingClientRect();
    const screenPadding = 16;
    const calendarWidth = 300;
    const calendarHeight = 400;

    let left = rect.left;
    let top = rect.bottom + window.scrollY + 5;

    if (left + calendarWidth > window.innerWidth - screenPadding) {
      left = window.innerWidth - calendarWidth - screenPadding;
    }

    if (left < screenPadding) {
      left = screenPadding;
    }

    if (
      top + calendarHeight >
      window.innerHeight + window.scrollY - screenPadding
    ) {
      top = rect.top + window.scrollY - calendarHeight - 5;
    }

    return createPortal(
      <div
        className="fixed inset-0 z-[9999]"
        onClick={(e) => {
          if (e.target === e.currentTarget) {
            setIsOpen(false);
          }
        }}
      >
        <div
          className="absolute bg-white rounded-lg shadow-lg p-2"
          style={{
            left,
            top,
            maxWidth: "calc(100vw - 32px)",
            maxHeight: "calc(100vh - 32px)",
          }}
        >
          <DatePicker
            selected={value ? new Date(value) : null}
            onChange={handleDateSelect}
            dateFormat="yyyy-MM-dd"
            inline
            popperClassName="react-datepicker-popper"
          />
        </div>
      </div>,
      document.getElementById("portal-root")
    );
  };

  return (
    <div className={`relative ${className}`}>
      <label className="text-sm font-medium text-gray-500">{label}</label>
      <div className="relative">
        <input
          ref={inputRef}
          type="text"
          value={value ? value.split("T")[0] : ""}
          readOnly
          onClick={() => !disabled && setIsOpen(!isOpen)}
          className={`mt-0.5 block w-full px-2 py-1 border border-gray-300 rounded-md shadow-sm text-sm
            ${
              disabled
                ? "bg-gray-100 text-gray-500 cursor-not-allowed"
                : "bg-white text-gray-900 cursor-pointer"
            } pr-8`}
        />
        <div className="absolute inset-y-0 right-0 flex items-center pr-2 mt-0.5">
          <CalendarIcon onClick={() => !disabled && setIsOpen(!isOpen)} />
        </div>
        <Calendar />
      </div>
    </div>
  );
};

export default DatePickerField; 